var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('b-container',[_c('b-img',{attrs:{"id":_vm.thumbnailID,"rounded":"","fluid":"","src":_vm.signedUrl,"alt":"Thumbnail image is not available."}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }